import React, { useContext } from "react";
import { MediaContext } from "./media-context";

import EditColumn from "./EditColumn";
import MediaStatusSelect from "./MediaStatusSelect";

const EditContentGroupStatus = () => {
  const context = useContext(MediaContext);

  const formBuilder = handlers => {
    return (
      <MediaStatusSelect
        mediaType={context.media.mediaType}
        onChange={handlers.onMediaStatusChange}
        value={context.media.status || ""}
      />
    );
  };

  return <EditColumn formBuilder={formBuilder} />;
};

export default EditContentGroupStatus;
